/* eslint-disable class-methods-use-this */ import { LobbyImage } from '@colonist/types';
import { ArrayUtils } from '@colonist/utils';
import { CA } from '../../../shared/scripts/analytics/Analytics.ts';
import { UINotificationController, UITopNotificationType } from '../../../shared/scripts/notifications/UINotificationController.ts';
import { SocketLobbySend } from '../../../shared/scripts/socket/SocketLobbySend.ts';
import { UIMNotificationView } from './UIMNotificationView.ts';
import { throttleUserAction } from '../../../shared/scripts/ui_utils/ClientUtils.ts';
import { uiManager } from '../EntryMobile.ts';
import { UIMSceneEnum } from '../../../../shared/enums/UIMSceneEnums.ts';
import { AnalyticEventCategory, AnalyticEventType } from '../../../../shared/entity_datas/EntityDatas.ts';
import { NotificationContentType } from '../../../shared/scripts/ui_utils/NotificationUtils.ts';
export class UIMNotificationController extends UINotificationController {
    show(text, type, buttonText, action, removeAction, showCloseButton = true, duration) {
        this.notifications.push({
            notificationView: new UIMNotificationView(text, type, buttonText, action, removeAction, undefined, showCloseButton, duration)
        });
    }
    showNotification(icon, text, duration, action, removeAction, contentType) {
        duration = duration !== null && duration !== void 0 ? duration : this.DURATION;
        if (this.shouldEditPreviousNotification()) return this.editPreviousNotification(duration, text);
        return this.createNotification(icon, text, duration, action, removeAction, contentType);
    }
    shouldEditPreviousNotification() {
        if (this.notifications.length == 0) return false;
        const notificationTypesToEdit = [
            NotificationContentType.Volume
        ];
        const lastNotification = this.notifications[this.notifications.length - 1];
        return notificationTypesToEdit.includes(lastNotification.notificationView.contentType);
    }
    editPreviousNotification(duration, text) {
        const lastNotification = this.notifications[this.notifications.length - 1];
        clearTimeout(lastNotification.timeout);
        this.setNotificationTimeout(lastNotification, duration);
        lastNotification.notificationView.updateText(text);
        return lastNotification.notificationView;
    }
    createNotification(icon, text, duration, action, removeAction, contentType = NotificationContentType.General) {
        const type = this.getTypeFromIcon(icon);
        const newNotificationView = new UIMNotificationView(text, type, undefined, action, removeAction, contentType);
        const newNotification = {
            notificationView: newNotificationView
        };
        this.notifications.push(newNotification);
        this.setNotificationTimeout(newNotification, duration);
        const newRemoveAction = ()=>{
            if (removeAction != undefined) removeAction();
            this.removeNotification(newNotification);
        };
        newNotificationView.updateRemoveAction(newRemoveAction);
        this.removeExtraPopup();
    }
    showGames(games) {
        if (uiManager.sceneController.scene == UIMSceneEnum.Game) return;
        for (const game of games){
            if (this.gameIds.includes(game.id)) continue;
            if (this.rejectedGameIds.includes(game.id)) continue;
            this.gameIds.push(game.id);
            const text = game.disconnected ? {
                key: 'strings:homePage.notifications.disconnectedFromGame',
                options: {
                    playerCount: game.playerCount,
                    gameId: game.id
                }
            } : {
                key: 'strings:homePage.notifications.activeGame',
                options: {
                    playerCount: game.playerCount,
                    gameId: game.id
                }
            };
            this.show(text, UITopNotificationType.Reconnect, {
                key: 'strings:homePage.notifications.reconnect'
            }, throttleUserAction(()=>{
                const userReconnecting = {
                    type: AnalyticEventType.MobileGameUserLeftGame,
                    category: AnalyticEventCategory.MobileAnalytics,
                    stringValue: 'reconnect'
                };
                void CA.sendAnalyticEventsWithMobileDimensions(userReconnecting);
                SocketLobbySend.reconnectGame(game.id);
            }), ()=>{
                ArrayUtils.removeElementFromArray(this.gameIds, game.id);
                this.rejectedGameIds.push(game.id);
            });
        }
    }
    removeDisconnectBanners() {
        this.removeBanners(UITopNotificationType.Reconnect);
    }
    removeSocketErrorBanners() {
        this.removeBanners(UITopNotificationType.SocketError);
    }
    setNotificationTimeout(notification, duration) {
        notification.timeout = setTimeout(()=>{
            this.removeNotification(notification);
        }, duration);
    }
    removeNotification(notification) {
        if (!ArrayUtils.removeElementFromArray(this.notifications, notification)) return;
        notification.notificationView.close();
        clearTimeout(notification.timeout);
    }
    getTypeFromIcon(icon) {
        switch(icon){
            case LobbyImage.InfoIcon:
                return UITopNotificationType.Information;
            case LobbyImage.CheckMark:
                return UITopNotificationType.Success;
            case LobbyImage.Lightning:
                return UITopNotificationType.Warning;
            case LobbyImage.DangerIcon:
                return UITopNotificationType.Error;
            default:
                return UITopNotificationType.Information;
        }
    }
    removeBanners(type) {
        const matchingNotifications = this.notifications.filter((notification)=>notification.notificationView.type == type);
        for (const notification of matchingNotifications){
            clearTimeout(notification.timeout);
            notification.notificationView.hide();
            ArrayUtils.removeElementFromArray(this.notifications, notification);
        }
    }
    removeExtraPopup() {
        if (this.notifications.length <= this.MAX_POPUPS) return;
        this.removeNotification(this.notifications[0]);
    }
    constructor(...args){
        super(...args), this.gameIds = [], this.rejectedGameIds = [], this.notifications = [], this.DURATION = 5000, this.MAX_POPUPS = 5;
    }
}
